import { FC } from 'react'
import { MenuNames } from '../../header'
import arrowRight from './../../../../../assets/Navbar/arrow-right.svg';
import ImageComponent from '../../atoms/ImageComponent';
import ButtonComponent from '../../atoms/ButtonComponent';
import HomesForSaleMenuItem from './HomesForSaleMenuItem';
import DesktopMenuItem from './DesktopMenuItem';
import { menuOpts } from './desktopMenuItemsOpts';
import LinkComponent from '../../atoms/LinkComponent';
import { buildUrlUsingBase } from '../../../../../constants';

type IProps = {
    variant: MenuNames,
    onMouseLeave: () => void;
}

const DesktopMenuTemplate: FC<IProps> = ({ variant, onMouseLeave }) => {
    return (
            <div
                className={`transition-all absolute top-[100%] left-0 right-0 z-30 shadow-lg bg-white flex flex-row`} onMouseLeave={() => {
                    onMouseLeave()
                }}
            >
                <div
                    className="flex flex-col justify-center items-start gap-[15px] w-[321px] bg-[#F1F0F0] px-[54px] py-[77px]"
                >
                    <ImageComponent
                        source={menuOpts.images[variant]}
                        alt="nav-image-type"
                    />
                    <h2 className="font-semibold text-[36px] md:text-sectionHeading leading-[100%] capitalize tracking-tighter font-cormorant-garamond text-[#1a1a1a]">{menuOpts.headings[variant]}</h2>
                    <p className="text-[#666666]  text-[15px] leading-[150%]">
                        {menuOpts.subHeading[variant]}
                    </p>
                    <LinkComponent to={menuOpts.cta[variant]}>
                        <ButtonComponent size='large' variant='contained' className="!px-[26px] !h-[38.89px]">
                            <ImageComponent
                                source={arrowRight}
                                alt="arrow-right"
                            />
                        </ButtonComponent>
                    </LinkComponent>
                </div>
                <div className="flex border-t-[1px] border-[#eeeeee] grow">
                    <div className="flex flex-col grow">
                        <div className="mt-[24px] px-[24px] pb-[12px] border-[#EEEEEE] border-b-[1px] text-[#1a1a1a] text-[15px] font-bold">{menuOpts.labels[variant]}</div>
                        <div className="flex flex-col pt-[9px] gap-[9px]">
                            {menuOpts.mainCol[variant].map(eachEntry => <DesktopMenuItem key={eachEntry.id} to={eachEntry.to}>{eachEntry.label}</DesktopMenuItem>)}
                        </div>
                    </div>
                    <div className="w-[1px] bg-[#EEEEEE]">&nbsp;</div>
                    <div className="flex flex-col grow">
                        <div className="mt-[24px] px-[24px] pb-[12px] border-[#EEEEEE] border-b-[1px] text-[#1a1a1a] text-[15px] font-bold">Tools</div>
                        <div className="flex flex-col pt-[9px] gap-[9px]">
                            {menuOpts.toolsCol[variant].map(eachEntry => <DesktopMenuItem key={eachEntry.id} to={eachEntry.to}>{eachEntry.label}</DesktopMenuItem>)}
                        </div>
                    </div>
                    <div className="w-[1px] bg-[#EEEEEE]">&nbsp;</div>
                    <div className={`flex flex-col ${variant === 'sell' ? 'grow-[4]' : 'grow'}`}>
                        <div className="mt-[24px] px-[24px] pb-[12px] border-[#EEEEEE] border-b-[1px] text-[#1a1a1a] text-[15px] font-bold">Resources</div>
                        <div className="flex flex-col pt-[9px] gap-[9px]">
                            {menuOpts.resourcesCol[variant].map(eachEntry => <DesktopMenuItem key={eachEntry.id} to={eachEntry.to}>{eachEntry.label}</DesktopMenuItem>)}
                        </div>
                    </div>
                    <div className="w-[1px] bg-[#EEEEEE]">&nbsp;</div>
                    {variant !== 'sell' ? <div className="flex flex-col grow bg-[rgba(228,233,211,0.27)]">
                        <div className="mt-[24px] px-[24px] pb-[12px] border-[#EEEEEE] border-b-[1px] text-[#1a1a1a] text-[15px] font-bold">Homes for Sale</div>
                        <div className="flex flex-col pt-[9px] gap-[9px]">
                            <HomesForSaleMenuItem to="https://www.zown.ca/">Homes for sale near me</HomesForSaleMenuItem>
                            <HomesForSaleMenuItem to="https://www.zown.ca/">Open houses near me</HomesForSaleMenuItem>
                            <HomesForSaleMenuItem to="https://www.zown.ca/">Homes for sale in Ontario</HomesForSaleMenuItem>
                            <HomesForSaleMenuItem to="https://www.zown.ca/">Homes for sale in Ontario</HomesForSaleMenuItem>
                            <HomesForSaleMenuItem to="https://www.zown.ca/">Condos for sale near me</HomesForSaleMenuItem>
                        </div>
                    </div> : null}
                </div>
            </div>
    )
}

export default DesktopMenuTemplate